var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteresumePr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.80567 12.5355L15.8049 12.6338M3.80647 12.4373C3.78712 13.619 4.00071 14.793 4.43506 15.8922C4.86942 16.9914 5.51601 17.9942 6.33794 18.8435C7.15987 19.6928 8.14104 20.3719 9.22541 20.8421C10.3098 21.3122 11.4761 21.5641 12.6579 21.5834C13.8396 21.6028 15.0136 21.3892 16.1128 20.9549C17.212 20.5205 18.2149 19.8739 19.0642 19.052C19.9135 18.23 20.5926 17.2489 21.0627 16.1645C21.5328 15.0801 21.7847 13.9138 21.8041 12.732C21.8234 11.5503 21.6098 10.3763 21.1755 9.27713C20.7411 8.17794 20.0945 7.17506 19.2726 6.32576C18.4507 5.47646 17.4695 4.79737 16.3851 4.32725C15.3007 3.85714 14.1344 3.60521 12.9527 3.58586C11.7709 3.56651 10.5969 3.7801 9.49774 4.21445C8.39855 4.6488 7.39568 5.2954 6.54638 6.11733C5.69707 6.93926 5.01798 7.92042 4.54787 9.0048C4.07775 10.0892 3.82583 11.2555 3.80647 12.4373Z",
    stroke: "#4C5966",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteresumePr);
export default __webpack_public_path__ + "static/media/deleteresumePR.fbed936803f375b554468f4c183ea0af.svg";
export { ForwardRef as ReactComponent };